import { dmyToYmd } from './reportDateParams'
import type { WeeklyReimbursementsListPatch } from '../types/utils'
import { WEEKLY_REIMBURSEMENTS_SESSION_KEY } from '../constants/sessionKeys'

export { WEEKLY_REIMBURSEMENTS_SESSION_KEY }

export function readWeeklyReimbursementsSession(): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(WEEKLY_REIMBURSEMENTS_SESSION_KEY)
    if (!raw) return null
    const v = JSON.parse(raw) as unknown
    return typeof v === 'object' && v !== null && !Array.isArray(v) ? (v as Record<string, unknown>) : null
  } catch {
    return null
  }
}

export function writeWeeklyReimbursementsSession(data: Record<string, unknown>): void {
  sessionStorage.setItem(WEEKLY_REIMBURSEMENTS_SESSION_KEY, JSON.stringify(data))
}

export function clearWeeklyReimbursementsSession(): void {
  sessionStorage.removeItem(WEEKLY_REIMBURSEMENTS_SESSION_KEY)
}

function normalizeStoredDate(value: unknown): string {
  if (value == null) return ''
  const s = String(value).trim()
  if (!s) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  return dmyToYmd(s) || s
}

export function sessionFilterToWeeklyReimbursementsPatch(
  session: Record<string, unknown>,
): WeeklyReimbursementsListPatch {
  const patch: WeeklyReimbursementsListPatch = {}
  if (typeof session.page === 'number' && session.page > 0) patch.page = session.page
  if (typeof session.perPage === 'number' && session.perPage > 0) patch.perPage = session.perPage
  if (session.sortBy === 'asc' || session.sortBy === 'desc') patch.sortBy = session.sortBy
  if (typeof session.orderBy === 'string' && session.orderBy.trim()) patch.orderBy = session.orderBy
  if (typeof session.year === 'string') patch.year = session.year
  const fromDt = normalizeStoredDate(session.fromDt)
  const toDt = normalizeStoredDate(session.toDt)
  if (fromDt) patch.fromDt = fromDt
  if (toDt) patch.toDt = toDt
  if (Array.isArray(session.week_filter)) {
    patch.week_filter = session.week_filter.map(String)
  } else if (typeof session.week_filter === 'string' && session.week_filter) {
    patch.week_filter = [session.week_filter]
  }
  return patch
}

export function buildWeeklyReimbursementsSessionFromParams(p: {
  page: number
  perPage: number
  sortBy: string
  orderBy: string
  fromDt: string
  toDt: string
  year: string
  week_filter: string[]
}): Record<string, unknown> {
  return {
    page: p.page,
    perPage: p.perPage,
    sortBy: p.sortBy,
    orderBy: p.orderBy,
    year: p.year,
    fromDt: p.fromDt,
    toDt: p.toDt,
    week_filter: p.week_filter,
  }
}
